import { bufferToHexString } from '@iotize/common/byte-converter';
import { TapRequestFrame } from '@iotize/tap/client/api';

import { TapRequestFrameBuilder } from './tap-request-builder';

export class TapRequestHelper {
  // static toString(request: TapRequestFrame) {
  //     return `${TapRequestFrame.MethodType[request.header.methodType]} ${TapRequestHelper.pathToString(request.header.path)}`;
  // }

  static toString(
    request: TapRequestFrame,
    options?: {
      printMaxId?: boolean;
    },
  ) {
    let result = `${
      TapRequestFrame.MethodType[request.header.methodType]
    } ${TapRequestHelper.pathToString(request.header.path, options)}`;
    if (request.payload && request.payload.length > 0) {
      result += ` 0x${bufferToHexString(request.payload)}`;
    }
    return result;
  }

  static pathToString(
    path: TapRequestFrame.Path,
    options?: {
      printMaxId?: boolean;
    },
  ): string {
    const resourceInstanceId = (path as any)['resourceInstanceId'];
    return (
      '/' +
      path.objectId +
      '/' +
      (path.objectInstanceId === TapRequestFrameBuilder.MAX_ID
        ? options?.printMaxId
          ? path.objectInstanceId
          : ''
        : path.objectInstanceId) +
      '/' +
      path.resourceId +
      (resourceInstanceId ? '/' + resourceInstanceId : '')
    );
  }
}
